<template>
    <div id="app">
        <div id="wrapper">
            <Menu v-if="routeName != 'sermonslive' && routeName != 'sermonsRemote'"/>
            <router-view />
        </div>
    </div>
</template>

<script>
import Menu from './components/Menu.vue';

export default {
    name: "app",
    components: { Menu },
    data: function() {
        return {   
            routeName: ""
        }
    },
    mounted: function() { 
        this.routeName = this.$route.name;
    },
    updated() {
        this.routeName = this.$route.name;
    }
};
</script>

<style>
  @import './App.css';
</style>
